import { Action, createReducer, on } from "@ngrx/store";
import { ApiClientState } from "../../models/api-client-state";
import { ApiAccessActions } from "../../actions/api-access.actions";
import * as _ from "lodash";
import { produce } from "immer";

const initialState: ApiClientState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ApiAccessActions.apiClient.getApi, (state) => ({
		clients: _.cloneDeep(state.clients),
		loading: true
	})),
	on(ApiAccessActions.apiClient.getSuccess, (state, action) => {
		return produce(state, (draft) => {
			draft.clients = getMergedClients(action, state.clients || []);
			draft.loading = false;
		});
	}),
	on(ApiAccessActions.apiClient.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	),
	on(ApiAccessActions.apiClient.createClientSuccess, (state, action) => {
		return produce(state, (draft) => {
			draft.clients = getMergedClients(action, state.clients || []);
			draft.loading = false;
		});
	}),
	on(ApiAccessActions.apiClient.removeClientSuccess, (state, action) => {
		const clients = _.cloneDeep(_.get(state, "clients", []));
		_.remove(clients, (client) => client.clientId === action.clientId);
		return { clients, loading: false };
	})
);

function getMergedClients(action, existingClients: any[]): any {
	return produce(existingClients, (draftClients) => {
		const index = draftClients.findIndex((client) => action.clientId === client.clientId);
		if (index !== -1) {
			draftClients[index] = { ...draftClients[index], ...action };
		} else {
			draftClients.unshift(action);
		}
	});
}

export function apiClientReducer(
	state: ApiClientState | undefined,
	action: Action
): ApiClientState {
	return reducer(state, action);
}
